
<template>
  <div class="ds-study" id="dsxx" ref="scrollContainer">
    <div class="dsxx-content">
      <ContentTitle title="党史学习" :hideMore="true"></ContentTitle>
      <div class="dscont-up">
        <div class="dsxx-person">
          <div class="dsxx-per">
            <div class="dsrw-tit">党史人物</div>
            <div class="dsrw-tab-cont">
              <div class="dsrw-tab">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane
                    v-for="(item, i) in historyMembers"
                    :key="item.id"
                  >
                    <span slot="label">{{ item.columnName }}</span>

                    <div class="swiper-father" v-if="activeName == i">
                      <div
                        class="swiper-container leader-swiper"
                        :id="`swiper${i}`"
                      >
                        <div class="swiper-wrapper">
                          <div
                            class="swiper-slide"
                            v-for="(it, index) in swiperLeaderList[Number(activeName)]"
                            :key="index"
                            :title="it.title"
                          >
                            <a
                              :href="`/#/DsxxXqy/${type}/${activeName}/${index}/${uidList[index]}`"
                              target="_blank"
                              class="event-img"
                            >
                              <img :src="it.src" alt="" />
                              <span>{{ it.name }}</span></a
                            >
                          </div>
                        </div>
                      </div>
                      <div class="swiper-button-prev"></div>
                      <!--左箭头。如果放置在swiper外面，需要自定义样式。-->
                      <div class="swiper-button-next"></div>
                      <!--右箭头。如果放置在swiper外面，需要自定义样式。-->
                    </div>
                  </el-tab-pane>
                </el-tabs>
                <div class="more-box">
                  <el-link
                    class="more"
                    type="info"
                    :href="`/#/DsxxPage/${activeName}`"
                    target="_blank"
                  >
                    查看更多
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#iconmore"></use>
                    </svg>
                  </el-link>
                </div>
              </div>
            </div>
          </div>
          <div class="basic-knowledge">
            <el-link
              class="zdsj-title"
              type="info"
              :href="zggcdzlHref"
              target="_blank"
            >
              党的基础知识
            </el-link>
            <el-link
              class="zdsj-title"
              type="info"
              href="/#/partyLanguage"
              target="_blank"
            >
            党的知识学习助手
            </el-link>
          </div>
        </div>
        <!--历次党代会-->
        <el-tabs
          :tab-position="tabPosition"
          v-model="current"
          class="ds-meeting"
          @tab-click="getHYData"
        >
          <el-tab-pane v-for="item in labelList" :key="item">
            <span slot="label">{{ item }}</span>
            <div class="dsmeet-cont">
              <el-scrollbar ref="scroll" style="height: 350px">
                <ul class="dsmeet-list">
                  <li
                    v-for="(item, i) in hyList"
                    :key="item.id"
                    class="dsmeet-cont1"
                  >
                    <a
                      :href="
                        Number(current)
                          ? `/#/QuanHuiParty/HYGB${7-i}`
                          : `/#/LidaiParty/BgqwPage${20 - i}`
                      "
                      target="_blank"
                    >
                      <h4>{{ item.columnName }}</h4>
                      <p>
                        {{ abstractList[Number(current)][i] }}
                      </p>
                    </a>
                  </li>
                </ul>
              </el-scrollbar>
              <el-link
                class="more posa"
                type="info"
                :href="current === '0' ? '/#/LidaiParty' : '/#/QuanHuiParty'"
                target="_blank"
              >
                查看更多
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#iconmore"></use>
                </svg>
              </el-link>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <!--重大事件-->
      <div class="dscont-down">
        <el-link
          class="zdsj-title"
          type="info"
          href="/#/DnjzhdPage"
          target="_blank"
        >
          党内集中教育活动
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#iconmore"></use>
          </svg>
        </el-link>
        <div class="swiper-out">
          <div class="swiper-container" id="zdsjSwiper">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, i) in bannerList"
                :key="i"
                :title="item.title"
              >
                <a
                  :href="`/#/DnjzhdPage/${item.id}`"
                  target="_blank"
                  class="event-img"
                >
                  <img :src="item.src" alt="" />
                  <span>{{ item.title }}</span></a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import jyhd1 from "../../assets/images/jyhd/01.png";
import jyhd2 from "../../assets/images/jyhd/02.png";
import jyhd3 from "../../assets/images/jyhd/03.png";
import jyhd4 from "../../assets/images/jyhd/04.png";
import jyhd5 from "../../assets/images/jyhd/05.png";
import jyhd6 from "../../assets/images/jyhd/06.png";
import jyhd7 from "../../assets/images/jyhd/07.png";
import jyhd8 from "../../assets/images/jyhd/08.png";
import jyhd9 from "../../assets/images/jyhd/09.jpg";
import jyhd10 from "../../assets/images/xxp.jpg";
import jyhd11 from "../../assets/images/jyhd/11.jpg";

import "swiper/css/swiper.css";
import Swiper from "swiper";
import ContentTitle from "../../components/ContentTitle.vue";
import { mixin } from "../../mixins/mixin";
import $ from 'jquery';
export default {
  mixins: [mixin],
  data() {
    return {
      activeName: "0",
      current: "0",
      tabPosition: "left",
      index: 1,
      zggcdzlHref: "",
      bannerList: [
      {
        id: 1269,
        title:"深入贯彻中央八项规定精神学习教育",
        src: jyhd11,
      },
        {
          id: 1215,
          src: jyhd10,
          title: "党纪学习教育",
        },
        {
          id: 584,
          src: jyhd9,
          title: "学习贯彻习近平新时代中国特色社会主义思想主题教育",
        },
        {
          id: 477,
          src: jyhd8,
          title: "党史学习教育",
        },
        {
          id: 476,
          src: jyhd7,
          title: "“不忘初心、牢记使命”主题教育",
        },
        {
          id: 474,
          src: jyhd6,
          title: "“三严三实”专题教育",
        },
        {
          id: 473,
          src: jyhd5,
          title: "党的群众路线教育实践活动",
        },
        {
          id: 469,
          src: jyhd4,
          title: "“三讲”教育活动",
        },
        {
          id: 465,
          src: jyhd3,
          title: "整风运动",
        },
        {
          id: 464,
          src: jyhd2,
          title: "整党运动",
        },{
          id: 463,
          src: jyhd1,
          title: "延安整风运动",
        },
      ],
      labelList: ["历次党代会", "十九大以来的历次全会"],
      hyUidList: [
        "487c1060-6112-498a-b13c-a8e9c9129e82",
        "22fc538e-7942-47c2-a752-2590aa4d5d2c",
      ],
      hyList: [],
      abstractList: [
        [
          "中国共产党第二十次全国代表大会，是在全党全国各族人民迈上全面建设社会主义现代化国家新征程、向第二个百年奋斗目标进军的关键时刻召开的一次十分重要的大会。",
          "中国共产党第十九次全国代表大会，是在全面建成小康社会决胜阶段、中国特色社会主义进入新时代的关键时期召开的一次十分重要的大会。",
          "中国共产党第十八次全国代表大会，是在我国进入全面建成小康社会决定性阶段召开的一次十分重要的大会。大会的主题是：高举中国特色社会主义伟大旗帜，以邓小平理论、“三个代表”重要思想、科学发展观为指导，解放思想，改革开放，凝聚力量，攻坚克难，坚定不移沿着中国特色社会主义道路前进，为全面建成小康社会而奋斗。",
          "中国共产党第十七次全国代表大会，是在我国改革发展关键阶段召开的一次十分重要的大会。大会的主题是：高举中国特色社会主义伟大旗帜，以邓小平理论和“三个代表”重要思想为指导，深入贯彻落实科学发展观，继续解放思想，坚持改革开放，推动科学发展，促进社会和谐，为夺取全面建设小康社会新胜利而奋斗。",
          "中国共产党第十六次全国代表大会，是我们党在新世纪召开的第一次代表大会，也是我们党在开始实施社会主义现代化建设第三步战略部署的新形势下召开的一次十分重要的代表大会。"
        ],
        [
          "中国共产党第十九届中央委员会第七次全体会议，于2022年10月9日至12日在北京举行。",
          "中国共产党第十九届中央委员会第六次全体会议，于2021年11月8日至11日在北京举行。",
          "中国共产党第十九届中央委员会第五次全体会议，于2020年10月26日至29日在北京举行。",
          "中国共产党第十九届中央委员会第四次全体会议，于2019年10月28日至31日在北京举行。",
          "中国共产党第十九届中央委员会第三次全体会议，于2018年2月26日至28日在北京举行。",
        ],
      ],
      swiper: null,
    };
  },
  components: {
    ContentTitle,
  },
  mounted() {
    // 下面是普通swiper模板
    this.swiper = new Swiper("#zdsjSwiper", {
      slidesPerView: 6,
      spaceBetween: 16,
      // autoplay: {
      //   delay: 2500,
      //   // pauseOnMouseEnter:true
      // },
      touchStartPreventDefault: false,
    });
    window.addEventListener('scroll', this.handleScroll,true)
    this.swiper.el.onmouseover = function () {
      this.swiper.autoplay.stop();
    };
    this.swiper.el.onmouseleave = function () {
      this.swiper.autoplay.start();
    };
  },
  created() {
    this.getZggcdzlHref();
    this.getHYData();
  },
  methods: {
    handleScroll () {
      var scrollTop = $('#app').scrollTop();
      var scrollTop1 = this.$refs.scrollContainer.offsetTop - window.innerHeight + this.$refs.scrollContainer.clientHeight
      if(scrollTop >= scrollTop1 ) {
        setTimeout(() => {
          this.swiper.autoplay.start();
        },1000)
      }
    },
    handleClick(tab) {
      this.type = this.historyMembers[tab.index].columnName
      this.getUidList()
      this.$nextTick(() => {
        new Swiper(`#swiper${tab.index}`, {
          slidesPerView: 4,
          spaceBetween: 20,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          touchStartPreventDefault: false,
        });
      });
    },
    getZggcdzlHref() {
      this.axios
        .post("data/custom/buildlist", {
          uid: "e58aacb5-2645-4a60-a10f-ce2b8fea205b",
          pageNum: 1,
          pageSize: 10,
        })
        .then((res) => {
          if (res.status == 200) {
            this.zggcdzlHref = res.data.rows[0].linkUrl;
          } else {
            this.$message.error("获取失败！");
          }
        });
    },
    getHYData() {
      this.axios
        .get(
          `data/custom/classType?uid=${
            this.hyUidList[Number(this.current)]
          }&pageNum=1&pageSize=10`
        )
        .then((res) => {
          if (res.status == 200) {
            this.hyList = res.data.rows.filter((item, i) => i < 5);
            new Swiper("#swiper0", {
              slidesPerView: 4,
              spaceBetween: 20,
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
              touchStartPreventDefault: false,
            });
          } else {
            this.$message.error("获取失败！");
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.swiper-out {
  background: url(../../assets/images/swiper_bg.png) no-repeat;
  padding: 20px;
  height: 213px;
  .swiper-container {
    background: #fff;
    padding: 15px;
    .event-img {
      display: block;
      font-size: 16px;
      color: #383636;
      img {
        width: 175px;
        height: 108px;
        margin-bottom: 5px;
      }
      span {
        display: block;
        line-height: 1.6;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      &:hover {
        color: #de1c26;
      }
    }
  }
}
::v-deep {
  .ds-meeting {
    .el-tabs__header {
      &.is-left {
        margin-right: 0;
      }
    }
    .el-tabs__nav-wrap.is-left::after {
      content: normal;
    }
    .el-tabs__active-bar.is-left {
      display: none;
    }
    .el-tabs__nav {
      display: flex;
      flex-direction: column;
      white-space: normal;
      height: 391px;
    }
    .el-tabs__item {
      width: 60px;
      padding: 013px 18px;
      line-height: 1;
      height: auto;
      flex: 1;
      font-size: 20px;
      color: #bd1a2d;
      background: #ffe9eb;
      &.is-active {
        color: #f9fdcc;
        background: #bd1a2d;
        font-size: 24px;
      }
    }
  }
}
.ds-study {
  width: 100%;
  height: 861px;
  margin-top: 40px;
  background: url("../../assets/images/dsxx_bg.png") no-repeat center center;
  background-size: cover;
  .dsxx-content {
    width: 1200px;
    height: auto;
    overflow: hidden;
    margin: 0 auto;
    box-sizing: border-box;
    .dscont-up {
      width: 1200px;
      height: 391px;
      display: flex;
      justify-content: space-between;

      .dsxx-person {
        width: 620px;
        height: 391px;
        .dsxx-per {
          display: flex;
          justify-content: space-between;
          height: 264px;
          .dsrw-tit {
            width: 60px;
            height: 264px;
            background: #bd1a2d;
            font-weight: 700;
            font-size: 24px;
            writing-mode: vertical-rl; //从右往左排 vertical-lr是从左往右排
            letter-spacing: 18px; //设置间距
            text-align: center;
            box-sizing: border-box;
            padding-right: 15px;
            color: #f9fdcc;
          }
          .dsrw-tab-cont {
            width: 560px;
            height: 264px;
            background: url("../../assets/images/dsrw_tab_bg.png") no-repeat;
            .dsrw-tab {
              width: 525px;
              height: 230px;
              margin: 20px 20px 0 20px;
              .swiper-father {
                padding: 0 34px;
              }
              .swiper-slide {
                img {
                  width: 100px;
                  height: 100px;
                  border-radius: 50%;
                }
                .event-img {
                  span {
                    display: block;
                    text-align: center;
                    font-size: 16px;
                    line-height: 2;
                  }
                }
              }
              .swiper-button-prev,
              .swiper-button-next {
                color: #bd1a2d;
                &::after {
                  font-size: 20px;
                }
              }
              .swiper-button-prev {
                left: -7px;
              }
              .swiper-button-next {
                right: 2px;
              }
              ::v-deep {
                .el-tabs__item {
                  height: 40px;
                  padding: 0 20px;
                  text-align: center !important;
                  margin-right: 10px;
                  font-size: 18px !important;
                  background: #ffe9eb;
                }
                .el-tabs__item:hover {
                  color: #bd1a2d;
                  cursor: pointer;
                }
                .el-tabs__item.is-active {
                  color: #fff;
                  background: linear-gradient(
                    90deg,
                    #bd1a2d 0.09%,
                    #ec0e0e 100%
                  );
                }
                .el-tabs__nav-wrap::after {
                  display: none;
                }
                .el-tabs__active-bar {
                  display: none;
                }
              }

              .dsrm-leader {
                margin-top: 10px;
                position: relative;
                .dsrm-leader-arrl {
                  position: absolute;
                  top: 35px;
                  font-size: 2em;
                  color: #ffbaba;
                }
                .dsrm-leader-arrrt {
                  position: absolute;
                  top: 35px;
                  right: 0;
                  font-size: 2em;
                  color: #bd1a2d;
                }
                p {
                  margin-top: 15px;
                  text-align: right;
                  color: #9f9fa6;
                  img {
                    margin-left: 5px;
                    vertical-align: -3px;
                  }
                }
                ul {
                  display: flex;
                  box-sizing: border-box;
                  padding-left: 30px;

                  li {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-right: 20px;
                    img {
                      margin-bottom: 5px;
                    }
                  }
                }
              }
            }
          }
        }
      }
      .basic-knowledge {
        margin-top: 21px;
        width: 620px;
        height: 90px;
        // background: url("../../assets/images/ddjczd_bg.png") no-repeat;
        display: flex;
        .el-link {
          flex: 1;
          background: url("../../assets/images/ddjczs.png") no-repeat;
          font-size: 24px;
          line-height: 106px;
          letter-spacing: 1px;
          color: #f9fdcc;
          &:first-child{
            ::v-deep(.el-link--inner) {
              padding-left: 75px;
            }
          }
          &+.el-link{
            margin-left: 8px;
            background-image: url("../../assets/images/ddxxzs.png");
          }
          img {
            vertical-align: -2px;
          }
        }
      }
      .ds-meeting {
        display: flex;
        width: 557px;
        height: 391px;
        .dsmeet-tab {
          width: 60px;
          height: 391px;
          background: #ffe9eb;
          text-align: center;
          font-size: 20px;

          .dsmeet-tab-up {
            width: 60px;
            height: 151px;
            word-wrap: break-word;
            letter-spacing: 15px;
            font-weight: 700;
            box-sizing: border-box;
            line-height: 23px;
            padding: 18px 0 0 17px;
          }
          .dsmeet-tab-up.active {
            color: #f9fdcc;
            background: #bd1a2d;
          }
          .dsmeet-tab-down {
            width: 60px;
            height: 239px;
            line-height: 22px;
            color: #bd1a2d;
            font-weight: 700;
            word-wrap: break-word;
            letter-spacing: 15px;
            box-sizing: border-box;
            padding: 10px 0 0 16px;
          }
        }
        .dsmeet-cont {
          width: 497px;
          height: 391px;
          box-sizing: border-box;
          background: url("../../assets/images/every_meetbg.png") no-repeat;
          .more {
            bottom: 15px;
          }
          .dsmeet-list {
            // height: 350px;
            padding: 0 19px;
          }
          .dsmeet-cont1 {
            width: 447px;
            border-bottom: 1px dotted #b1aeae;
            a {
              padding: 15px 0;
              h4 {
                font-size: 18px;
                color: #000000;
                margin-bottom: 10px;
              }
              &:hover {
                h4 {
                  color: #de1c26;
                }
              }
            }
            p {
              color: #9f9fa6;
              line-height: 28px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }
          span {
            display: block;
            text-align: right;
            margin-right: 30px;
            color: #9f9fa6;
            img {
              margin-left: 5px;
              vertical-align: -3px;
            }
          }
        }
      }
    }
    .dscont-down {
      width: 1200px;
      margin-top: 20px;
      text-align: center;
      .zdsj-title {
        display: block;
        font-weight: 700;
        font-size: 24px;
        color: #bd1a2d;
        letter-spacing: 1px;
        line-height: 80px;
        background: url("../../assets/images/zdsj_bg.png") no-repeat;
        &:hover{
          &::after{
            display: none;
          }
        }
        img {
          vertical-align: -3px;
          display: inline-block;
        }
      }
    }
  }
}
</style>